import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47ec3f2b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-center" }
const _hoisted_2 = { class: "text-gray-700" }
const _hoisted_3 = {
  key: 0,
  class: "text-3xl plus"
}
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "flex-center mt-2" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "description" }
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { class: "text-gray-700 mb-1" }, "Categories:", -1))
const _hoisted_10 = { class: "flex-center-between" }
const _hoisted_11 = { class: "vars flex-grow mt-4" }
const _hoisted_12 = {
  key: 0,
  class: "text-gray-700"
}
const _hoisted_13 = {
  key: 0,
  class: "var-input"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputTextarea = _resolveComponent("InputTextarea")!
  const _component_GPTSettings = _resolveComponent("GPTSettings")!
  const _component_InputSwitch = _resolveComponent("InputSwitch")!
  const _component_LogIn = _resolveComponent("LogIn")!
  const _component_RunButton = _resolveComponent("RunButton")!
  const _component_Result = _resolveComponent("Result")!
  const _component_Accordeon = _resolveComponent("Accordeon")!

  return (_openBlock(), _createBlock(_component_Accordeon, {
    "onUpdate:value": [
      _ctx.sendOpened,
      _cache[12] || (_cache[12] = ($event: any) => ((_ctx.accordeonValue) = $event))
    ],
    class: _normalizeClass(["prompt item mt-1 rounded", {'is-new': _ctx.isNew}]),
    hideToggler: _ctx.isNew,
    value: _ctx.accordeonValue
  }, {
    title: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.isNew)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: _normalizeClass(["fav mr-2 text-xl hover:text-yellow-400", {'text-yellow-400': _ctx.isInFav}]),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleFav && _ctx.toggleFav(...args)))
            }, _toDisplayString(_ctx.isInFav? "★" : "☆"), 3))
          : _createCommentVNode("", true),
        _createElementVNode("b", _hoisted_2, [
          (_ctx.isNew)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, "+"))
            : _createCommentVNode("", true),
          _createTextVNode(),
          _createElementVNode("span", null, _toDisplayString(_ctx.isNew ? 'Add a new one'  : _ctx.prompt?.name), 1)
        ]),
        (!_ctx.isNew)
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              class: "ml-2 text-gray-500 text-sm share-btn",
              href: _ctx.link,
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.copyLink && _ctx.copyLink(...args)), ["prevent"]))
            }, "🔗", 8, _hoisted_4))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      (_openBlock(), _createElementBlock("div", {
        key: _ctx.prompt?.id || 'prompt_new'
      }, [
        _createElementVNode("div", null, [
          (_ctx.isNew || _ctx.canEdit)
            ? (_openBlock(), _createBlock(_component_InputText, {
                key: 0,
                label: "Name",
                value: _ctx.prompt?.name || '',
                "onUpdate:value": _cache[2] || (_cache[2] = (val) => _ctx.$emit('update', {field: 'name', value: val}))
              }, null, 8, ["value"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showContent = !_ctx.showContent, _ctx.showSettings = false))),
              class: "mr-2 underline rounded text-sm"
            }, _toDisplayString(_ctx.showContent ? 'Hide' : (_ctx.canEdit ? 'Edit' : 'Show')) + " Prompt ", 1),
            (_ctx.showContent && !_ctx.isNew)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.copy(_ctx.prompt?.content || ''))),
                  class: "bg-yellow-400 px-2 rounded text-white text-sm mr-2"
                }, "Copy"))
              : _createCommentVNode("", true),
            (_ctx.showContent && !_ctx.isNew)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.copyToChatGPT && _ctx.copyToChatGPT(...args))),
                  class: "bg-green-400 px-2 rounded text-white text-sm"
                }, "Copy to ChatGPT"))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showSettings = !_ctx.showSettings, _ctx.showContent = false))),
              class: "ml-2 underline rounded text-sm"
            }, [
              _createTextVNode(_toDisplayString(_ctx.showSettings ? 'Hide' : 'Show') + " Settings ", 1),
              (_ctx.settingsIsNotDefault)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, "*"))
                : _createCommentVNode("", true)
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_7, " Use format $varName:inputType or $varName (default input) ", 512), [
            [_vShow, _ctx.showContent && _ctx.canEdit]
          ]),
          _withDirectives(_createVNode(_component_InputTextarea, {
            value: _ctx.prompt?.content || '',
            class: "w-full mt-2",
            disabled: !_ctx.canEdit,
            "onUpdate:value": _cache[7] || (_cache[7] = (val) => _ctx.$emit('update', {field: 'content', value: val}))
          }, null, 8, ["value", "disabled"]), [
            [_vShow, _ctx.showContent]
          ]),
          (_ctx.showSettings)
            ? (_openBlock(), _createBlock(_component_GPTSettings, {
                key: 1,
                value: _ctx.gptSettings,
                "onUpdate:value": _ctx.updateGPTSettings
              }, null, 8, ["value", "onUpdate:value"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_component_InputSwitch, {
              class: "mt-1",
              multiselect: "",
              value: _ctx.prompt?.categories_ids,
              options: _ctx.categories?.map((category) => ({label: category.name, value: category.id})),
              "onUpdate:value": _cache[8] || (_cache[8] = (val) => _ctx.$emit('update', {field: 'categories_ids', value: val})),
              disabled: !_ctx.canEdit
            }, null, 8, ["value", "options", "disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_ctx.variables.length)
              ? (_openBlock(), _createElementBlock("b", _hoisted_12, "Variables:"))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.variables, (variable, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "var mt-2 mb-2",
                key: i
              }, [
                (_ctx.variables.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (!variable.inputType || variable.inputType === 'default' || variable.inputType === 'text')
                        ? (_openBlock(), _createBlock(_component_InputText, {
                            key: 0,
                            label: _ctx.capitalize(variable.name) + ': ',
                            value: _ctx.varValues[variable.name],
                            "onUpdate:value": ($event: any) => ((_ctx.varValues[variable.name]) = $event)
                          }, null, 8, ["label", "value", "onUpdate:value"]))
                        : _createCommentVNode("", true),
                      (variable.inputType === 'textarea')
                        ? (_openBlock(), _createBlock(_component_InputTextarea, {
                            key: 1,
                            label: _ctx.capitalize(variable.name) + ': ',
                            class: "w-full",
                            value: _ctx.varValues[variable.name],
                            "onUpdate:value": ($event: any) => ((_ctx.varValues[variable.name]) = $event)
                          }, null, 8, ["label", "value", "onUpdate:value"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (_ctx.isNew)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.user)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: "add-btn px-8 py-1 rounded",
                        onClick: _cache[9] || (_cache[9] = () => (_ctx.$emit('add', _ctx.prompt),_ctx.accordeonValue = true) )
                      }, "Add"))
                    : (_openBlock(), _createBlock(_component_LogIn, { key: 1 }))
                ], 64))
              : (_openBlock(), _createBlock(_component_RunButton, {
                  key: 2,
                  onRun: _ctx.run,
                  showKeyDescription: _ctx.showKeyDescription,
                  disabled: _ctx.isLoading,
                  isLoading: _ctx.isLoading
                }, null, 8, ["onRun", "showKeyDescription", "disabled", "isLoading"]))
          ]),
          (_ctx.canDelete)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "bg-red-300 px-2 py-1",
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('del')))
              }, "Delete"))
            : _createCommentVNode("", true)
        ]),
        (_ctx.result)
          ? (_openBlock(), _createBlock(_component_Result, {
              key: 0,
              result: _ctx.result,
              class: "mt-4",
              onCopy: _cache[11] || (_cache[11] = val => _ctx.copy(val || _ctx.result))
            }, null, 8, ["result"]))
          : _createCommentVNode("", true)
      ]))
    ]),
    _: 1
  }, 8, ["onUpdate:value", "class", "hideToggler", "value"]))
}